export const SHIP_STATES: any = {
    BO: 'Borrador',
    PE: 'Pendiente',
    AP: 'Aprobado',
    RE: 'Rechazado',
    SB: 'Stand-By',
    PA: 'Pausado'
};

export const CERTIFICATE_STATES: any = {
    BO: 'Borrador',
    PE: 'Pendiente',
    AP: 'Aprobado',
    RE: 'Rechazado',
    VE: 'Vencido'
};

export const CERTIFICATE_ABREVIATE_STATE: any = {
    Borrador: 'BO',
    Pendiente: 'PE',
    Aprobado: 'AP',
    Rechazado: 'RE',
    Vencido: 'VE'
};

export const STEPS_VALIDATIONS: any = {
    1: 'firstStepValidated',
    2: 'secondStepValidated',
    3: 'thirdStepValidated',
    4: 'fourthStepValidated'
};

export const GIROS_STATES: any = {
    pendiente: 'pendiente',
    pendiente_pago_reserva: 'pendiente pago reserva',
    aceptado: 'aceptado', // por AGP
    anulado: 'anulado',
    aprobado: 'aprobado', // por AGP
    cancelado: 'cancelado', // por AM
    rechazado: 'rechazado', // por PNA
    denegado: 'denegado', // solicitud denegada por AGP
    operando: 'operando',
    finalizado: 'finalizado',
    modificando: 'modificando',
    revision: 'revision',
    liquidado: 'liquidado',
    pendiente_liquidar: 'pendiente liquidar',
    proximo_pendiente: 'próximo pendiente',
    modificando_revision: 'modificando revisión',
    cancelado_con_penalidad: 'cancelado con penalidad', // AE4-409 — cancelación con penalidad (Art. 13/14)
    pendiente_autorizar_reserva: 'pendiente autorizar reserva', // estado previo a pendiente de pago de reserva
    pendiente_respuesta_ruptura: 'pend. resp. ruptura' // AE4-577 — espera respuesta agencia por desplazamiento a RADA
};

// AE4-409 — Códigos de línea de penalidad en pasavante y sus claves i18n (namespace giros).
export const PENALIDAD_CODES = [
    'PENALIDAD_ANTICIPO',
    'PENALIDAD_PORCENTAJE',
    'PENALIDAD_CARGO_300'
] as const;
export type PenalidadCode = (typeof PENALIDAD_CODES)[number];
export const PENALIDAD_CODE_OBS_KEY: Record<PenalidadCode, string> = {
    PENALIDAD_ANTICIPO: 'penalidades.cancelacion.anticipoPerdido',
    PENALIDAD_PORCENTAJE: 'penalidades.cancelacion.usoPuerto',
    PENALIDAD_CARGO_300: 'penalidades.cancelacion.cargo300'
};

// AE4-432 — Recargo por inactividad operativa del buque (Art. 9). Const de código + clave i18n (namespace giros).
export const RECARGO_INACTIVIDAD_OPERATIVA = 'RECARGO_INACTIVIDAD_OPERATIVA' as const;
export const RECARGO_INACTIVIDAD_OPERATIVA_LABEL_KEY = 'detalleCalculo.recargoInactividadOperativa';

// AE4-636 — Recargo por buque sin equipo contra incendios (Art. 6°).
export const RECARGO_SIN_EQUIPO_INCENDIOS = 'RECARGO_SIN_EQUIPO_INCENDIOS' as const;

// AE4-639 — Recargo por incumplimiento de giro a muelle (Art. 15°).
export const RECARGO_INCUMPLIMIENTO_MUELLE = 'RECARGO_INCUMPLIMIENTO_MUELLE' as const;

// AE4-409 — Mapa estado de giro → color del badge. Fallback en `default`.
export const GIROS_STATE_COLORS: { [key: string]: { bgc: string; color: string } } = {
    pendiente: { bgc: '#F0AF06', color: '#fff' },
    pendiente_pago_reserva: { bgc: '#F0AF06', color: '#fff' },
    pendiente_autorizar_reserva: { bgc: '#F0AF06', color: '#fff' },
    aceptado: { bgc: '#36ABFF', color: '#fff' },
    aprobado: { bgc: '#36FFC1', color: '#000' },
    operando: { bgc: '#3A36FF', color: '#fff' },
    finalizado: { bgc: '#A737FF', color: '#fff' },
    liquidado: { bgc: '#A737FF', color: '#fff' },
    pendiente_liquidar: { bgc: '#FF9737', color: '#000' },
    anulado: { bgc: '#9E9E9E', color: '#fff' },
    cancelado: { bgc: '#FF3636', color: '#fff' },
    rechazado: { bgc: '#FF3636', color: '#fff' },
    denegado: { bgc: '#FF3636', color: '#fff' },
    cancelado_con_penalidad: { bgc: '#FF3636', color: '#fff' },
    pendiente_respuesta_ruptura: { bgc: '#FF9737', color: '#000' }, // AE4-577 — naranja
    default: { bgc: '#E0E0E0', color: '#000' }
};

export const PATENT_STATES: any = {
    PENDIENTE: 'pendiente',
    APROBADO: 'aprobado', // por AGP
    CANCELADO: 'cancelado', // por AM
    DENEGADO: 'denegado', // solicitud denegada por AGP
    LIQUIDADO: 'liquidado' //
};

export const CERTIFICATES_NAMES: any = {
    1: 'Arqueo',
    2: 'Matrícula',
    3: 'Seguro P&I',
    4: 'Seguro Casco & Máquina',
    5: 'Navegación',
    6: 'Certificado 1010/94',
    7: 'Seguro de Caución',
    8: 'Green Award',
    9: 'Environmental Ship Index ESI',
    11: 'Bandera'
};

// AE4-712 — Catálogo de período unificado, parametrizado por periodicidad (mensual en Ushuaia, trimestral en el resto).
export type Periodicidad = 'mensual' | 'trimestral';

const QUARTER_PERIOD_FULL: { [key: number]: string } = {
    1: '1 (ENE - MAR)',
    2: '2 (ABR - JUN)',
    3: '3 (JUL - SEP)',
    4: '4 (OCT - DIC)'
};

const QUARTER_OPTIONS = [
    { id: 1, nombre: 'Enero-Marzo' },
    { id: 2, nombre: 'Abril-Junio' },
    { id: 3, nombre: 'Julio-Septiembre' },
    { id: 4, nombre: 'Octubre-Diciembre' }
];

export const getPeriodoOptions = (periodicidad: Periodicidad): { id: number; nombre: string }[] =>
    periodicidad === 'mensual'
        ? MONTHS.map((nombre, index) => ({ id: index + 1, nombre }))
        : QUARTER_OPTIONS;

export const getPeriodoLabel = (valor: number, periodicidad: Periodicidad): string =>
    periodicidad === 'mensual' ? MONTHS[valor - 1] || '' : QUARTER_PERIOD_FULL[valor] || '';

export const getPeriodoFieldLabel = (periodicidad: Periodicidad): string =>
    periodicidad === 'mensual' ? 'Mes' : 'Trimestre';

export const PASAVANTE_STATES: any = [
    { id: 1, nombre: 'Liquidados', value: 'liquidado' },
    { id: 2, nombre: 'Por liquidar', value: 'pendiente_liquidar' }
];

export const INSPECTION_STATES: any = [
    { id: 1, nombre: 'Pendiente', value: 'pendiente' },
    { id: 2, nombre: 'Control OK', value: 'control oK' },
    { id: 3, nombre: 'Resuelto', value: 'resuelto' },
    { id: 4, nombre: 'Observado', value: 'observado' }
];

export const STATE_OPTIONS_FOR_FILTERS: any = [
    { id: 1, nombre: 'Activo', value: true },
    { id: 2, nombre: 'Inactivo', value: false }
];

export const RAILWAY_STATE_OPTIONS: any = [
    { id: 1, nombre: 'Ingreso Cargado' },
    { id: 2, nombre: 'Egreso Cargado' },
    { id: 3, nombre: 'Ingreso Vacío' },
    { id: 4, nombre: 'Egreso Vacío' }
];

export const SERVICIOS_NAVE_STATES: any = [
    { id: 1, nombre: 'PENDIENTE', value: 'Pendiente' },
    { id: 2, nombre: 'APROBADO', value: 'Aprobado' },
    { id: 3, nombre: 'APROVISIONADO', value: 'Aprovisionado' },
    { id: 4, nombre: 'LIQUIDADO', value: 'Liquidado' },
    { id: 5, nombre: 'CANCELADO', value: 'Cancelado' },
    { id: 6, nombre: 'PENDIENTE LIQUIDAR', value: 'Pendiente liquidar' }
];

export const SITIO_BGC: { [key: number]: any } = {
    0: { bgc: '#FFF', color: '#000' },
    1: { bgc: '#F0AF06', color: '#fff' },
    2: { bgc: '#A737FF', color: '#fff' },
    3: { bgc: '#FF3636', color: '#fff' },
    4: { bgc: '#3A36FF', color: '#fff' },
    5: { bgc: '#36FFC1', color: '#000' },
    6: { bgc: '#FF9737', color: '#000' },
    7: { bgc: '#35FCFF', color: '#000' },
    8: { bgc: '#FF37A1', color: '#fff' },
    9: { bgc: '#FFF734', color: '#000' },
    10: { bgc: '#36ABFF', color: '#000' }
};

export const ID_ORG_USHUAIA = 2;
export const ID_TIPO_OPERACION_PASAJEROS = 3;
export const NOMBRE_TIPO_OPERACION_PASAJEROS = 'Pasajeros';
export const ID_PERFIL_AGENCIAS_MARITIMAS = 2;
export const NOMBRE_PERFIL_AGENCIAS_MARITIMAS = 'AGENCIAS MARITIMAS';

export const BOOKING_STATES: { [key: string]: string } = {
    PENDIENTE: 'PENDIENTE', // se crea la reserva
    EDITADA: 'EDITADA', // se edita (desde AUTORIZADA)
    AUTORIZADA: 'AUTORIZADA', // un empleado de backoffice la autoriza
    RECHAZADA: 'RECHAZADA', // un empleado de backoffice la rechaza
    CANCELADA: 'CANCELADA', // posterior a pendiente o autorizada y la cancela Agencia Maritima (solo la puede cancelar mientras este pendiente o autorizada)
    PENDIENTE_LIQUIDAR: 'PENDIENTE LIQUIDAR', // solicitud de liquidación por parte de la agencia
    LIQUIDADA: 'LIQUIDADA',
    PAGO_DECLARADO: 'PAGO_DECLARADO',
    PAGO_REVISION: 'PAGO_REVISION',
    PAGADA: 'PAGADA'
};

// RN-05 (listado de reservas). La pantalla de liquidación usa su propia regla —
// ESTADOS_POST_LIQUIDACION en Pasavantes/hooks/useLiquidacionReservas.ts — que hoy coincide
// en valores salvo PENDIENTE_LIQUIDAR, pero es una regla de negocio distinta e independiente.
export const ESTADOS_RESERVA_CON_DESCARGA_PDF_LISTADO = [
    'PENDIENTE_LIQUIDAR',
    'LIQUIDADA',
    'PAGO_DECLARADO',
    'PAGO_REVISION',
    'PAGADA'
] as const;

export const MONTHS = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
];

export const BOOKING_ACTIONS: {
    [key: string]: { menuText: string; action: string; message: string; functionId: number };
} = {
    autorizar: {
        menuText: 'Autorizar reserva',
        action: 'Reserva autorizada',
        message: '¿Confirmar autorización de reserva?',
        functionId: 107
    },
    rechazar: {
        menuText: 'Rechazar reserva',
        action: 'Reserva rechazada',
        message: '¿Confirmar rechazo de reserva?',
        functionId: 108
    },
    cancelar: {
        menuText: 'Cancelar reserva',
        action: 'Reserva cancelada',
        message:
            '¿Deseás cancelar la reserva seleccionada? Esta acción cambiará el estado a Cancelada.',
        functionId: 109
    },
    solicitar_factura: {
        menuText: 'Solicitar liquidación',
        action: 'Liquidación solicitada',
        message: '¿Confirmar solicitud de liquidación?',
        functionId: 110
    },
    liquidar_reserva: {
        menuText: 'Registrar liquidación',
        action: 'Liquidación registrada',
        message: '¿Confirmar liquidación de reserva?',
        functionId: 105
    },
    // Ciclo de pago post-liquidación (Ushuaia)
    generar_tasa: {
        menuText: 'Generar tasa',
        action: 'Tasa generada',
        message: '¿Confirmar generación de tasa?',
        functionId: 0 // TODO: confirmar functionId con Back-Gestion-Reservas (OQ-04)
    },
    adjuntar_comprobante: {
        menuText: 'Adjuntar comprobante',
        action: 'Comprobante adjuntado',
        message: '¿Confirmar adjunto de comprobante?',
        functionId: 112
    },
    validar_pago: {
        menuText: 'Validar pago',
        action: 'Pago validado',
        message: '¿Confirmar validación del pago?',
        functionId: 113
    },
    revisar_comprobante_pago: {
        menuText: 'Enviar a revisión',
        action: 'Comprobante enviado a revisión',
        message: '¿Confirmar envío a revisión?',
        functionId: 114
    }
};

export const PUERTO_MALVINAS = 'Malvinas Argentinas';

export const STRINGS_ZONAS = {
    RADA: 'RADA',
    RADA_FORZADA: 'RADA_FORZADA',
    POSIBLE_MUELLE_OPERATIVO: 'POSIBLE_MUELLE_OPERATIVO',
    MPO_DISPONIBLE: 'MPO_DISPONIBLE',
    RADA_VOLUNTARIA_CON_COBRO: 'RADA_VOLUNTARIA_CON_COBRO',
    RADA_NO_COMERCIAL: 'RADA_NO_COMERCIAL'
};
